import axios from "axios";
import FontHandler from "../_components/canvas/handlers/FontHandler";
import { DELETE_FONTS_ENDPOINT, FONTS_ENDPOINT, STORIES_FONTS_ENDPOINT } from "./endpoints";
import * as errorHandlerActions from "./errorHandlerActions";
import {
  GET_FONT_LIST,
  FONT_GET_ADDED,
  DELETE_FONT,
  FONTS_GET_ADDED,
  REMOVE_FONT_FROM_STATE,
  CHECK_IS_MOBILE_STATUS,
  RESET_FONTS_DATA,
  RESET_MY_FONTS,
  GET_ALL_FONT_LIST,
} from "./types";
const format = require("string-format");

export const fetchFonts =
  (props, signalToken, page = 1, isLoaded) =>
  (dispatch) => {
    return axios
      .get(`${FONTS_ENDPOINT}?page=${page}`, {
        cancelToken: signalToken.token,
      })
      .then((res) => {
        let fontHandler = new FontHandler();
        fontHandler.addFonts(res.data?.results);
        if (isLoaded) isLoaded(false);
        dispatch(fetchedFonts(res.data));
        return res.data;
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

export const resetFonts = () => {
  return {
    type: RESET_FONTS_DATA,
  };
};

export const fetchStoryFonts = (storyId, signalToken, props) => (dispatch) => {
  return axios
    .get(format(STORIES_FONTS_ENDPOINT, storyId), {
      cancelToken: signalToken.token,
    })
    .then((res) => {
      let font_handler = new FontHandler();
      font_handler.addFonts(res.data?.story_fonts);
      dispatch(fontsGetAdded(res.data?.story_fonts));
      return res.data;
    })
    .catch((error) => {
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    });
};

export const fetchedFonts = (data) => {
  return {
    type: GET_FONT_LIST,
    payload: data.results || [],
    loadMore: data.next !== null,
    previous: data.previous,
  };
};

export const fontGetAdded = (fontInfo) => {
  return {
    type: FONT_GET_ADDED,
    payload: fontInfo,
  };
};

export const fontsGetAdded = (fonts) => {
  return {
    type: FONTS_GET_ADDED,
    payload: fonts,
  };
};

export const deleteFont = (id, props) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(format(DELETE_FONTS_ENDPOINT, id))
      .then((res) => {
        dispatch({
          type: DELETE_FONT,
          payload: id,
        });
        resolve();
      })
      .catch((error) => {
        console.error("Delete font failed.\n", error);
        reject();
        // dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  });
};

export const removeFontFromState = (id) => (dispatch) => {
  dispatch({
    type: REMOVE_FONT_FROM_STATE,
    payload: id,
  });
};

export const checkIsMobileStatus = () => {
  return {
    type: CHECK_IS_MOBILE_STATUS,
  };
};


export const resetMyFontList = () => {
  return {
    type: RESET_MY_FONTS,
  };
};

export const fetchedAllFonts = (data) => {
  return {
    type: GET_ALL_FONT_LIST,
    payload: data.results || [],
    loadMore: data.next !== null,
    previous: data.previous,
  };
};

//Fetching all fonts recursively to find varients of any font we select or search from fonts drop-down
export const fetchAllFonts =
  (props, signalToken , page ) =>
  (dispatch) => {
      axios
      .get(`${FONTS_ENDPOINT}?page=${page}`, {
        cancelToken: signalToken.token,
      })
      .then((res) => {
        dispatch(fetchedAllFonts(res.data));
        if(res.data.next) return dispatch(fetchAllFonts(props, signalToken, page + 1));
        return;
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };
